import userAuthRoute from "./userAuthRoute";
import pagesRoute from "./pagesRoute";
import userPublicRoute from "./userPublicRoute";
import userProtectedRoute from "./userProtectedRoute";

export const authRoutes = [...userAuthRoute]
export const publicRoutes = [...userPublicRoute];
export const protectedRoutes = [...pagesRoute,...userProtectedRoute];

